/**
 * BLOCK: Howto - Deprecated Block
 */
import classnames from 'classnames';
import attributes from './attributes';

const { RichText, InnerBlocks } = wp.blockEditor;

const deprecated = [
	{
		attributes,
		save(props) {
			const { attributes, className } = props;

			const {
				block_id,
				headingTitle,
				headingDesc,
				headingTag,
				timeNeeded,
				time,
				timeIn,
				estCost,
				cost,
				currencyType,
				mainimage,
				toolsTitle,
				stepsTitle,
				materialTitle,
				tools,
				materials,
				schema,
				showTotaltime,
				showEstcost,
				showTools,
				showMaterials,
			} = attributes;

			let url_chk = '';
			let title = '';
			if (
				'undefined' !== typeof attributes.mainimage &&
				null !== attributes.mainimage &&
				'' !== attributes.mainimage
			) {
				url_chk = attributes.mainimage.url;
				title = attributes.mainimage.title;
			}

			let url = '';
			if ('' !== url_chk) {
				const size = attributes.mainimage.sizes;
				const imageSize = attributes.imgSize;

				if (
					'undefined' !== typeof size &&
					'undefined' !== typeof size[imageSize]
				) {
					url = size[imageSize].url;
				} else {
					url = url_chk;
				}
			}

			let image_icon_html = '';

			if (mainimage && mainimage.url) {
				image_icon_html = (
					<img
						className="wpsp-howto__source-image"
						src={url}
						title={title}
					/>
				);
			}

			return (
				<div
					className={classnames(className, `wpsp-block-${block_id}`)}
				>
					<script type="application/ld+json">{schema}</script>
					<div className="wpsp-how-to-main-wrap">
						<div className="wpsp-howto__wrap">
							<RichText.Content
								value={headingTitle}
								tagName={headingTag}
								className="wpsp-howto-heading-text"
							/>
							<RichText.Content
								value={headingDesc}
								tagName="p"
								className="wpsp-howto-desc-text"
							/>
							{mainimage.url && (
								<div className="wpsp-howto__source-wrap">
									{image_icon_html}
								</div>
							)}
							{showTotaltime && (
								<span className="wpsp-howto__time-wrap">
									<RichText.Content
										value={timeNeeded}
										tagName="h4"
										className="wpsp-howto-timeNeeded-text"
									/>
									<RichText.Content
										value={time}
										tagName="p"
										className="wpsp-howto-timeNeeded-value"
									/>
									<RichText.Content
										tagName="p"
										value={timeIn}
										className="wpsp-howto-timeINmin-text"
									/>
								</span>
							)}
							{showEstcost && (
								<span className="wpsp-howto__cost-wrap">
									<RichText.Content
										value={estCost}
										tagName="h4"
										className="wpsp-howto-estcost-text"
									/>
									<RichText.Content
										value={cost}
										tagName="p"
										className="wpsp-howto-estcost-value"
									/>
									<RichText.Content
										tagName="p"
										value={currencyType}
										className="wpsp-howto-estcost-type"
									/>
								</span>
							)}
						</div>
						{showTools && (
							<div className="wpsp-how-to-tools__wrap">
								<RichText.Content
									value={toolsTitle}
									tagName="h4"
									className="wpsp-howto-req-tools-text"
								/>
							</div>
						)}
						{showTools && (
							<div className="wpsp-tools__wrap">
								{tools.map((tools, index) => {
									return (
										<div
											className={classnames(
												`wpsp-how-to-tools-${index}`,
												'wpsp-how-to-tools-child__wrapper'
											)}
											key={index}
										>
											<div className="wpsp-tools">
												<RichText.Content
													tagName="div"
													value={
														tools.add_required_tools
													}
													className="wpsp-tools__label"
												/>
											</div>
										</div>
									);
								})}
							</div>
						)}
						{showMaterials && (
							<div className="wpsp-how-to-materials__wrap">
								<RichText.Content
									value={materialTitle}
									tagName="h4"
									className="wpsp-howto-req-materials-text"
								/>
							</div>
						)}
						{showMaterials && (
							<div className="wpsp-how-to-materials">
								{materials.map((materials, index) => {
									return (
										<div
											className={classnames(
												`wpsp-how-to-materials-${index}`,
												'wpsp-how-to-materials-child__wrapper'
											)}
										>
											<div className="wpsp-materials">
												<RichText.Content
													tagName="div"
													value={
														materials.add_required_materials
													}
													className="wpsp-materials__label"
												/>
											</div>
										</div>
									);
								})}
							</div>
						)}
						<div className="wpsp-how-to-steps__wrap">
							<RichText.Content
								value={stepsTitle}
								tagName="h4"
								className="wpsp-howto-req-steps-text"
							/>
							<div className="wpsp-howto-steps__wrap">
								<InnerBlocks.Content />
							</div>
						</div>
					</div>
				</div>
			);
		},
	},
];

export default deprecated;
